import axios from 'axios';
import config from './config';

const PLANS_URL = `${config.API_BASE_URL}/DesignPlans`;
const SUBS_URL = `${config.API_BASE_URL}/DesignSubscriptions`;

// ==================== PLANS (Admin with permission) ====================

export const fetchDesignPlans = async (includeInactive = false) => {
  const response = await axios.get(`${PLANS_URL}?includeInactive=${includeInactive}`);
  return response.data;
};

export const fetchDesignPlan = async (id) => {
  const response = await axios.get(`${PLANS_URL}/${id}`);
  return response.data;
};

export const createDesignPlan = async (data) => {
  const response = await axios.post(PLANS_URL, data);
  return response.data;
};

export const updateDesignPlan = async (id, data) => {
  const response = await axios.put(`${PLANS_URL}/${id}`, data);
  return response.data;
};

export const deleteDesignPlan = async (id) => {
  const response = await axios.delete(`${PLANS_URL}/${id}`);
  return response.data;
};

// ==================== PLAN WALLETS ====================

export const fetchPlanWallets = async (planId) => {
  const response = await axios.get(`${PLANS_URL}/${planId}/wallets`);
  return response.data;
};

export const assignWalletToPlan = async (planId, data) => {
  const response = await axios.post(`${PLANS_URL}/${planId}/wallets`, data);
  return response.data;
};

export const unassignWalletFromPlan = async (planId, walletId) => {
  const response = await axios.delete(`${PLANS_URL}/${planId}/wallets/${walletId}`);
  return response.data;
};

// ==================== SUBSCRIPTIONS (Purchase) ====================

export const purchasePlan = async (data) => {
  const response = await axios.post(`${SUBS_URL}/purchase`, data);
  return response.data;
};

export const fetchMySubscriptions = async (adminId) => {
  const response = await axios.get(`${SUBS_URL}/my/${adminId}`);
  return response.data;
};

export const fetchActiveSubscription = async (adminId) => {
  const response = await axios.get(`${SUBS_URL}/active/${adminId}`);
  return response.data;
};

// ==================== TRANSACTIONS (Admin with permission) ====================

export const fetchPendingDesignTransactions = async () => {
  const response = await axios.get(`${SUBS_URL}/transactions/pending`);
  return response.data;
};

export const fetchAllDesignTransactions = async (status, page = 1, limit = 50) => {
  let url = `${SUBS_URL}/transactions?page=${page}&limit=${limit}`;
  if (status) url += `&status=${status}`;
  const response = await axios.get(url);
  return response.data;
};

export const approveDesignTransaction = async (id, data) => {
  const response = await axios.put(`${SUBS_URL}/transactions/${id}/approve`, data);
  return response.data;
};

export const rejectDesignTransaction = async (id, data) => {
  const response = await axios.put(`${SUBS_URL}/transactions/${id}/reject`, data);
  return response.data;
};

// ==================== APPROVED SUBSCRIPTIONS (Design Management) ====================

export const fetchApprovedSubscriptions = async () => {
  const response = await axios.get(`${SUBS_URL}/approved`);
  return response.data;
};

export const fetchSubscriptionDetail = async (id) => {
  const response = await axios.get(`${SUBS_URL}/${id}`);
  return response.data;
};

// ==================== RECEIVED IMAGES (Admin without permission uploads) ====================

export const uploadReceivedImages = async (subscriptionId, data) => {
  const response = await axios.post(`${SUBS_URL}/${subscriptionId}/received-images`, data);
  return response.data;
};

export const fetchReceivedImages = async (subscriptionId) => {
  const response = await axios.get(`${SUBS_URL}/${subscriptionId}/received-images`);
  return response.data;
};

export const deleteReceivedImage = async (subscriptionId, imageId) => {
  const response = await axios.delete(`${SUBS_URL}/${subscriptionId}/received-images/${imageId}`);
  return response.data;
};

// ==================== SENT IMAGES (Admin with permission uploads) ====================

export const uploadSentImages = async (subscriptionId, data) => {
  const response = await axios.post(`${SUBS_URL}/${subscriptionId}/sent-images`, data);
  return response.data;
};

export const fetchSentImages = async (subscriptionId) => {
  const response = await axios.get(`${SUBS_URL}/${subscriptionId}/sent-images`);
  return response.data;
};

export const deleteSentImage = async (subscriptionId, imageId) => {
  const response = await axios.delete(`${SUBS_URL}/${subscriptionId}/sent-images/${imageId}`);
  return response.data;
};

// ==================== WALLETS (for plan wallet selection) ====================

export const fetchAllWallets = async () => {
  const response = await axios.get(`${config.API_BASE_URL}/Wallets`);
  return response.data;
};